import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class WorksRequest extends GenericRequest {

    term;
    page;
    filter;
    constructions_subcontracted;
    date;

    constructor(
        page,
        term = '',
        filter = 0,
        constructions_subcontracted = false,
        date = null,
    ) {
        super(METHOD_POST, ApiEndpoints.WORKS);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.constructions_subcontracted = constructions_subcontracted;
        this.date = date;
    }

    overrideRequest() {
        const request = {};
        request.retrieve_construction_contracts = false;
        request.criteria = {
            constructions_subcontracted: this.constructions_subcontracted,
        };
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.construction_state_ids = [this.filter];
        if ( this.date ) request.criteria.date = this.date.toISOFirstTime();
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/works/ws/WorksRequest.js